/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

export default class SpectralDensity extends EmberObject {
  frequencyArray;
  noiseSpecs;

  @computed('frequencyArray', 'noiseSpecs') get spectralDensity() {
    var frequencyArray = this.frequencyArray;
    var noiseSpecs = this.noiseSpecs;
    var result = this.getSpectralDensity(frequencyArray, noiseSpecs);
    return result;
  }

  getSpectralDensity(frequencyArray, noiseSpecs) {
    var magnitudeOfPreviousStage = frequencyArray.map(() => {
      return 1;
    });
    var totalSpectralNoiseRTI = frequencyArray.map(() => {
      return 0;
    });
    var spectralNoiseOfOneStageRTI = [];
    noiseSpecs.forEach((item) => {
      var tempSpectralNoiseOf1StageRTIArray = [];
      var spectralNoiseOfOneStage = item.noiseReferredToInputArray;
      frequencyArray.forEach((frequency, j) => {
        tempSpectralNoiseOf1StageRTIArray.push(spectralNoiseOfOneStage[j] / magnitudeOfPreviousStage[j]);
        totalSpectralNoiseRTI[j] = Math.sqrt(
          tempSpectralNoiseOf1StageRTIArray[j] * tempSpectralNoiseOf1StageRTIArray[j] +
            totalSpectralNoiseRTI[j] * totalSpectralNoiseRTI[j],
        );
        magnitudeOfPreviousStage[j] = magnitudeOfPreviousStage[j] * item.magnitude[j];
      });

      spectralNoiseOfOneStageRTI.push(tempSpectralNoiseOf1StageRTIArray);
    });

    var totalSpectralNoiseRTO = [];
    for (var i = 0; i < frequencyArray.length; i++) {
      var temptotalSpectralNoiseRTOValue = magnitudeOfPreviousStage[i] * totalSpectralNoiseRTI[i];
      totalSpectralNoiseRTO.push(temptotalSpectralNoiseRTOValue);
    }

    return { totalSpectralNoiseRTO: totalSpectralNoiseRTO, spectralNoiseOfOneStageRTI: spectralNoiseOfOneStageRTI };
  }
}
